<style lang="less">
@import "./OrderDetail.less";
.member-order-refund {
  display: flex;
  flex-direction: column;
  // padding-bottom: 70px;
  .order-product-list {
    flex: 0 0 100%;
    .order-product-list-header {
      flex: 0 0 100%;
    }
  }
  .member-order-list {
    .order-product-list {
      flex: 0 0 100%;
    }
  }
  /deep/.el-card {
    border-radius: 0;
    border: none;
  }
  /deep/.el-card__header {
    padding: 10px 20px;
    border: none;
  }
  /deep/.el-card__body {
    padding: 10px 20px;
  }
  .order-info {
    margin-top: 10px;
  }
  .product-info {
    margin-top: 10px;
    /deep/.el-card__body {
      padding: 0;
    }
  }
  .refund-info {
    margin-top: 10px;
  }
  .footer-button {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: white;
    padding: 10px;
    box-sizing: border-box;
  }
  .member-info {
    margin-top: 10px;
  }
  .address-input {
    width: 100%;
    height: 21px;
    align-items: center;
    background: white;
    display: flex;
    /deep/.el-input__inner {
      border: none !important;
      border-radius: 0;
      padding: 0;
      margin: 0;
    }
    input {
      border: none !important;
    }
  }
}
</style>

<template>
  <div class="member-order-refund">
    <el-card class="order-info" v-if="showRefundInfo()">
      <h3 slot="header">寄回信息</h3>
      <div class="flex col">
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>寄回地址:</span>
          <span class="margin-left">广州市黄埔区东区骏业路255号C栋4A</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>收件人:</span>
          <span class="margin-left">梁健怡 13392469518</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>快递公司:</span>
          <span class="margin-left">
            <el-input class="address-input" placeholder="请输入收货人信息" v-model="expressName"/>
          </span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>快递单号:</span>
          <span class="margin-left">
            <el-input class="address-input" placeholder="请输入收货人信息" v-model="expressNumber"/>
          </span>
        </div>
      </div>
    </el-card>
    <el-card class="order-info">
      <h3 slot="header">订单信息</h3>
      <div class="flex col">
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>订单号:</span>
          <span class="margin-left">{{ order.orderSn }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>下单时间:</span>
          <span class="margin-left">{{ order.createdAt }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>订单状态:</span>
          <span class="margin-left">{{ getOrderStatus(order) }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc">
          <span>支付方式:</span>
          <span class="margin-left">{{ $enums.payments.label(order.payMethod) }}</span>
        </div>
      </div>
    </el-card>
    <el-card class="product-info">
      <h3 slot="header">商品详情</h3>
      <OrderItem v-for="(orderProduct, index) of order.orderProducts" :key="index" :product="orderProduct"></OrderItem>
    </el-card>
    <el-card class="refund-info">
      <h3 slot="header">退款信息</h3>
      <div class="flex col">
        <div class="flex row padding-tb-sm flex-cc solid-bottom">
          <span>退款原因:</span>
          <span
            v-if="(type == 'detail' && order && order.refundRecord) || showRefundInfo()"
            class="margin-left"
          >{{ order.refundRecord.reason}}</span>
          <van-field
            v-else-if="reasons && reasons.length"
            readonly
            clickable
            label=""
            :value="reason"
            placeholder=""
            right-icon="arrow-down"
            style="width: 78%; padding: 0px 0px 0px 16px;"
            @click="showPicker = true"
          />
          <!-- <el-select
            v-else-if="reasons && reasons.length"
            class="margin-left"
            v-model="reason"
          >
            <el-option
              v-for="(item, index) in reasons"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select> -->
        </div>

        <div class="flex row  padding-tb-sm flex-cc solid-bottom" v-if="type == 'detail' && order && order.refundRecord" >
          <span>退款状态:</span>
          <span class="margin-left">{{ $enums.refundStatus.label(order.refundRecord.status) }}</span>
        </div>

        <div class="flex row  padding-tb-sm flex-cc solid-bottom" v-if="type == 'detail'" >
          <span>申请时间:</span>
          <span class="margin-left">{{ order && order.refundRecord && order.refundRecord.createdAt }}</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>退还渠道:</span>
          <span class="margin-left">{{ $enums.payments.label(order.payMethod) }}</span>
        </div>
        <div class="flex row padding-tb-sm flex-cc">
          <span>退款金额:</span>
          <span class="margin-left">{{ order.orderAmount }}</span>
        </div>
      </div>
    </el-card>
    <el-card class="order-info" v-if="showRefundCompleteInfo()">
      <h3 slot="header">寄回信息</h3>
      <div class="flex col">
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>寄回地址:</span>
          <span class="margin-left">广州市黄埔区东区骏业路255号C栋4A</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>收件人:</span>
          <span class="margin-left">梁健怡 13392469518</span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>快递公司:</span>
          <span class="margin-left">
            {{order.refundRecord.expressName}}
          </span>
        </div>
        <div class="flex row  padding-tb-sm flex-cc solid-bottom">
          <span>快递单号:</span>
          <span class="margin-left">
           {{order.refundRecord.expressNumber}}
          </span>
        </div>
      </div>
    </el-card>
    <!-- <div style="height:50px; background: #f4f4f4;"></div> -->
    <div class="footer-button flex flex-all-center shadow" v-if="!showRefundInfo()">
      <el-button v-if="showCancelButton" type="warning" style="width:80%;" @click="cancel">取消退款</el-button>
      <el-button v-else-if="type == 'confirm'" type="primary" style="width:80%;" @click="submit">提交申请</el-button>
    </div>
    <div class="footer-button flex flex-around shadow"  v-if="showRefundInfo()">
      <el-button  type="warning" style="width:40%;" @click="cancel">取消退款</el-button>
      <el-button  type="primary" style="width:40%;" @click="submitRefund">提交寄回信息</el-button>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="reasons"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <div style="height: 50px"></div>
  </div>
  <!-- <div
    class="member-order-refund"
    style="width:1100px;margin:0 auto;overflow-x:auto;"
  >
    <div class="member-order-header">
      <h2 class="solid-bottom padding-bottom">{{ type == 'detail' ? '退款详情' : '申请退款'}}</h2>
      <div class="flex row margin-top">
        <span>订单号: {{ order.orderSn }}</span>
        <span class="margin-left-xl">下单时间:{{ order.createdAt }}</span>
        <span class="margin-left-xl">支付方式:{{ $enums.payments.label(order.payMethod) }}</span>
      </div>
      <div class="margin-top flex col order-product-list member-order">
        <el-card>

          <div
            class="member-order-product-list-header"
            slot="header"
          >
            <div class="order-product-list-header">
              <div class="order-product-detailed">商品清单</div>
              <div class="order-product-number">数量</div>
              <div class="order-product-price">单价</div>
            </div>
          </div>

          <div class="member-order-list">
            <div class="order-product-list">
              <div
                class="order-product-item"
                v-for="(orderProduct, index) of order.orderProducts"
                :key="index"
              >
                <div class="order-product-detailed">
                  <img
                    :src="orderProduct.image"
                    class="order-product-image"
                    alt=""
                  >
                  <div>{{orderProduct.productName}}</div>
                </div>
                <div class="order-product-number">
                  {{orderProduct.number}}
                </div>
                <div class="order-product-price">
                  ¥{{orderProduct.salePrice}}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div class="member-card margin-top">
        <el-card>
          <div
            slot="header"
            class="flex row flex-sb padding-lr-xl"
          >
            <span>退款信息</span>
            <span v-if="type == 'detail' && order && order.refundRecord">{{ $enums.refundStatus.label(order.refundRecord.status ) }}</span>
          </div>
          <div class="flex col">
            <div class="flex row padding-tb-sm flex-cc">
              <span>退款原因:</span>
              <span
                v-if="type == 'detail' && order && order.refundRecord"
                class="margin-left"
              >{{ order.refundRecord.reason}}</span>
              <el-select
                v-else-if="reasons && reasons.length"
                class="margin-left"
                v-model="reason"
              >
                <el-option
                  v-for="(item, index) in reasons"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div
              class="flex row  padding-tb-sm flex-cc"
              v-if="type == 'detail'"
            >
              <span>申请时间:</span>
              <span class="margin-left">{{ order && order.refundRecord && order.refundRecord.createdAt }}</span>
            </div>
            <div class="flex row  padding-tb-sm flex-cc">
              <span>退还渠道:</span>
              <span class="margin-left">{{ $enums.payments.label(order.payMethod) }}</span>
            </div>
            <div class="flex row padding-tb-sm flex-cc">
              <span>退款金额:</span>
              <span class="margin-left">{{ order.orderAmount }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <div
        v-if="showCancelButton"
        class="flex flex-center margin-top-xl"
      >
        <el-button
          style="width:200px;"
          type="info"
          @click="cancel"
        >取消退款</el-button>
      </div>

      <div
        v-else-if="type == 'confirm'"
        class="flex flex-center margin-top-xl"
      >
        <el-button
          :loading="isSubmit"
          style="width:200px;"
          type="primary"
          @click="submit"
        >提交申请</el-button>
      </div>

    </div>
  </div> -->
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('refund')

import { payOrder, getOrderStatus } from "@/helpers/index";
import OrderItem from './components/OrderItem'
 import { Toast } from 'vant';
export default {
  components: {
    OrderItem
  },
  data() {
    return {
      showPicker: false,
      order: {

      },
      type: '',
      reason: null,
      isSubmit: false,
      expressNumber: '',
      expressName: ''
    }
  },
  computed: {
    ...mapState(['reasons']),

    showCancelButton() {
      if (this.type == 'detail' && this.order && this.order.refundRecord && (this.$enums.refundStatus.RO_UNSETTLED == this.order.refundRecord.status || this.order.refundRecord.status == 4)) {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions(['changeRefundOrderStatus']),
    showRefundInfo() {
      if(this.order.refundRecord&&this.order.refundRecord.status === 4) return true
      return false
    },
    showRefundCompleteInfo() {
      if(this.order.refundRecord&&(this.order.refundRecord.status === 5 || this.order.refundRecord.status == 2)&&this.order.refundRecord.expressName) return true
      return false
    },
    onConfirm(value) {
      this.reason = value;
      this.showPicker = false;
    },
    getOrderStatus(order) {
      return getOrderStatus(this.$enums, order)
    },

    async getOrder(id) {
      const { document } = await this.$store.dispatch('orders/document', id);
      this.order = document
    },

    async loadReasons() {
      await this.$store.dispatch('refund/loadReasons');
      if (this.reasons && this.reasons.length) {
        this.reason = this.reasons[0]
      }
    },

    async cancel() {
      try {
        await this.confirm('确定取消当前退款申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })

        await this.changeRefundOrderStatus({
          id: this.order.refundRecord.id,
          status: this.$enums.refundStatus.RO_CANCELLED
        })
        this.getOrder(this.order.id)
      } catch (error) {
        if (error.code == "5030" || error.code == "5033") {
          // 订单已经发货 订单已退款
          this.$router.replace({
            name: 'member-order-detail',
            params: {
              id: this.order.id
            }
          })
        } else {
          this.getOrder(this.order.id)
        }
      } finally {

      }
    },
    async submitRefund() {
      if (!this.expressName) {
        Toast('请输入快递公司名称');
        return
      }
      if (!this.expressNumber) {
        Toast('请输入快递单号');
        return
      }
      try {
        await this.$store.dispatch('refund/refundOrderInfo', {
          id: this.order.refundRecord.id,
          // status: 5,
          expressName: this.expressName,
          expressNumber: this.expressNumber
        })
        this.$toast.success({
          message: '提交成功',
          duration: 1000
        })
        setTimeout(() => {
          this.type = 'detail'
          this.getOrder(this.order.id)
          this.$router.replace({
            name: 'member-order-refund-detail',
            params: {
              id: this.order.id
            }
          })
        }, 1000)
      } catch (error) {
        console.log(error)
      }
    },
    async submit() {
      if (this.isSubmit) return
      try {
        this.isSubmit = true
        await this.$store.dispatch('refund/refundOrder', {
          orderId: this.order.id,
          reason: this.reason
        })

        // this.$message.success('提交成功')
        this.$toast.success({
          message: '提交成功',
          duration: 1000
        })
        setTimeout(() => {
          this.type = 'detail'
          this.getOrder(this.order.id)
          this.$router.replace({
            name: 'member-order-refund-detail',
            params: {
              id: this.order.id
            }
          })
        }, 1000)

      } catch (error) {
        if (error.code == "5030" || error.code == "5033") {
          // 订单已经发货 订单已退款
          this.$router.replace({
            name: 'member-order-detail',
            params: {
              id: this.order.id
            }
          })
        } else if (error.code == "5031") {
          // 订单已经申请
          this.type = 'detail'
          this.getOrder(this.order.id)
          this.$router.replace({
            name: 'member-order-refund-detail',
            params: {
              id: this.order.id
            }
          })
        }
        console.log(error.code)
        console.log(error)
      } finally {
        this.isSubmit = false
      }

    },
  },
  mounted() {
    const orderId = this.$route.params.id
    const { type } = this.$route.meta
    this.type = type
    this.getOrder(orderId);
    this.loadReasons()
  },
}
</script>
